import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/logo.webp'


const _hoisted_1 = { class: "relative bg-white" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center" }
const _hoisted_3 = { class: "flex flex-col w-56 flex-grow-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "MoodConnect"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_6 = { class: "md:hidden pr-6" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex-grow-0 space-x-4 pr-8 items-center hidden md:flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "grid" }
const _hoisted_12 = {
  key: 0,
  id: "freetrial"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/dashboard/teams" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Popover, { class: "relative" }, {
          default: _withCtx(() => [
            _createVNode(_component_PopoverButton, { class: "font-bold" }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuIcon, { class: "w-5 h-5 text-black" })
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PopoverPanel, { class: "origin-top-right absolute right-0 z-50 bg-white mt-4 w-56 shadow-xl rounded-md" }, {
                  default: _withCtx(() => [
                    (_ctx.loggedIn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_PopoverButton, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/dashboard/teams",
                                class: "text-left block px-4 py-2 w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Dashboard")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.msAppLoaded)
                            ? (_openBlock(), _createBlock(_component_PopoverButton, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: "/marketplace",
                                    class: "text-left block px-4 py-2 w-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Marketplace")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_PopoverButton, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/settings",
                                class: "text-left block px-4 py-2 w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Settings")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_PopoverButton, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "block px-4 py-2 font-bold text-inactive text-left w-full",
                                href: "#",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoutTapped && _ctx.logoutTapped(...args)))
                              }, "Log Out")
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_PopoverButton, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/login",
                                class: "text-left block px-4 py-2 w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Log In")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_PopoverButton, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/register",
                                class: "text-left block px-4 py-2 w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Sign Up")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", _hoisted_9, [
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/dashboard/teams",
                  class: "block px-4 py-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Dashboard")
                  ]),
                  _: 1
                })
              ]),
              (!_ctx.msAppLoaded)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: "/marketplace",
                      class: "block px-4 py-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Marketplace")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _createVNode(_component_Popover, { class: "relative" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PopoverButton, { class: "font-bold text-inactive" }, {
                      default: _withCtx(() => [
                        _createTextVNode("My Account")
                      ]),
                      _: 1
                    }),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition ease-out duration-100",
                      "enter-from-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-from-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PopoverPanel, { class: "origin-top-right absolute right-0 z-20 bg-white mt-4 w-56 shadow-xl rounded-md" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_PopoverButton, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: "/settings",
                                    class: "text-left block px-4 py-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Settings")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_PopoverButton, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    class: "block px-4 py-2 font-bold text-inactive text-left",
                                    href: "#",
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoutTapped && _ctx.logoutTapped(...args)))
                                  }, "Log Out")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "block px-4 py-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log In")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/register",
                  class: "block px-4 py-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign Up")
                  ]),
                  _: 1
                })
              ])
            ], 64))
      ])
    ]),
    (_ctx.freeTrialMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.freeTrialMessage) + " ", 1),
          _createVNode(_component_router_link, {
            class: "link",
            to: "/pricing"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Upgrade now")
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            id: "freetrialclose",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteFreeTrialMessage && _ctx.deleteFreeTrialMessage(...args)))
          }, "X")
        ]))
      : _createCommentVNode("", true)
  ]))
}